import React, { useEffect, useRef, useState } from "react";
import useIsMobile from '../../hooks/useIsMobile';

import '../../assets/styles/RangeQuestion.css';

const RangeQuestion = ({ question, value = 0, onChange }) => {
    // console.log('RangeQuestion', question);
    const isMobile = useIsMobile();
    const rangeRef = useRef(null);
    // const min = 0;
    // const max = question.step_quantity ?? 10;
    const steps = question.step_quantity ?? 11; // Ex: 11 para 0 a 10
    const min = 0;
    const max = steps - 1;
    const type = !question.reverse ? "-var" : "";

    // const safeValue = question.reverse ? max - Math.round(((value ?? 0) / 10) * max) : Math.round(((value ?? 0) / 10) * max);
    const normalized = Math.max(0, Math.min(10, Number(value ?? 0)));
    const rawValue = Math.round((normalized / 10) * max);
    const safeValue = !question.reverse ? max - rawValue : rawValue;

    const [displayValue, setDisplayValue] = useState(0);
    
    const isChecked = value !== "" && value !== undefined && value !== null;

    const [hoveredIndex, setHoveredIndex] = useState(null);

    const handleHover = (i) => {
        setHoveredIndex(i);
    };

    const handleMouseOut = () => {
        setHoveredIndex(null);
    };

    const getThumbColor = (percent) => {
        // console.log('getThumbColor', percent, symFor);
        let negative;
        let positive;

        if(!question.reverse){
            negative = '#F02E14';
            positive = '#446D41';
            if (percent < 10) return "#666666";
            if (percent < 40) return negative;
            if (percent < 80) return "#F0B214";
            return positive;
        } else {
            negative = '#446D41';
            positive = '#F02E14';
            if (percent < 10) return "#666666";
            if (percent < 40) return negative;
            if (percent < 80) return "#F0B214";
            return positive;
        }
    };

    // useEffect(() => {
    //     if (!rangeRef.current || isNaN(safeValue)) return;
    
    //     const percent = (safeValue > 0) ? ((safeValue - min) / (max - min)) * 100 : 100;
    //     const adjusted = percent < 80 ? percent : percent / 2;
    
    //     const thumbColor = getThumbColor((displayValue == 0) ? 0 : percent, question.sym_for);
    
    //     rangeRef.current.style.setProperty("--progress", `${adjusted}%`);
    //     rangeRef.current.style.setProperty("--progress2", `${percent}%`);
    //     rangeRef.current.style.setProperty("--thumb-color", thumbColor);
    // }, [safeValue, question.sym_for]);

    useEffect(() => {
        if (!rangeRef.current || isNaN(safeValue)) return;

        const sliderValue = displayValue;
        const percent = (sliderValue > 0) ? ((sliderValue - min) / (max - min)) * 100 : 0;
        const adjusted = percent < 80 ? percent : percent / 2;
        
        const thumbColor = getThumbColor((displayValue === 0) ? 0 : percent);

        rangeRef.current.style.setProperty("--progress", `${adjusted}%`);
        rangeRef.current.style.setProperty("--progress2", `${percent}%`);
        rangeRef.current.style.setProperty("--thumb-color", thumbColor);
    }, [displayValue, max, question.reverse]);

    useEffect(() => {
        if (value === null || value === undefined || value === "") {
            setDisplayValue(0); // valor padrão para não interagido = 0
            // Não propaga resposta para perguntas opcionais (checkbox) ainda não marcadas,
            // senão o item "não marcado" vira uma resposta real de valor 0 na anamnese.
            if (!question.optional) {
                onChange(0);
            }
        } else if (typeof value === "number" && !isNaN(value)) {
            // O valor salvo é sempre 0-10
            // Para normal: displayValue = value; Para invertido: displayValue = max - value
            let adjusted;
            if (question.reverse === 1) {
                adjusted = value;
            } else {
                adjusted = value;
            }
            setDisplayValue(adjusted);
        }
    }, [value, max, question.reverse, question.optional]);

    const showSlider = !question.optional || isChecked;

    return (
        <div className={`range-question range-question-container ${!question.optional ? 'question py-4 pb-5 py-lg-5' : 'two'}`}>
            <div className="row">
                {question.icon && (
                    <div className="col-auto rangeIcon">
                        <img src={`${process.env.PUBLIC_URL}/assets/images/svg/${question.icon}`} alt={question.label} />
                    </div>
                )}
                <div className="col">
                    {!question.optional && (
                        <div className="chat-message">
                            {!question.optional && (
                                <h4
                                    className="mb-0"
                                    dangerouslySetInnerHTML={{
                                        __html:
                                            question.label +
                                            (!question.optional ? "" : "")
                                    }}
                                />
                            )}
                            {question.sym_for === 1 && question.sublabel && <p className="mt-2" dangerouslySetInnerHTML={{ __html: question.sublabel }} />}

                            {isMobile && question.sym_explain ? (
                                <p className="mt-2">
                                    {question.sym_explain.split('|').map((item, index) => (
                                    <span key={index}>
                                        <strong>{index}</strong> - {item}
                                        {index < question.sym_explain.split('|').length - 1 && ' | '}
                                    </span>
                                    ))}
                                </p>
                            ) : (
                                ""
                            )}


                        </div>
                    )}
                    
                    {!!question.optional && (
                        <label>
                            <div className="row align-items-center my-1">
                                <div className="col-auto">
                                    <input
                                        type="checkbox"
                                        className="big-checkbox"
                                        checked={isChecked}
                                        onChange={(e) => {
                                            const checked = e.target.checked;
                                            const newValue = checked ? 1 : "";
                                            setDisplayValue(Number(newValue));
                                            onChange(Number(newValue))
                                        }}
                                    />
                                </div>
                                <div className="col ps-0">
                                    <p className="m-0">{question.label}</p>
                                </div>
                            </div>
                        </label>
                    )}

                    {showSlider && (
                        
                        <div className={`slider-container ${!question.optional ? 'pt-3' : 'pt-2 pb-5'}`}>
                            <input
                                type="range"
                                ref={rangeRef}
                                className={`form-range${type}`}
                                min={min}
                                max={max}
                                value={displayValue}
                                onChange={(e) => {
                                    const raw = Number(e.target.value);
                                    // Salvar sempre o valor lógico, sem inversão
                                    setDisplayValue(raw);
                                    onChange(raw);
                                }}
                            />
                            <div className="container">
                                <div className="range-labels row justify-content-between">
                                    {[...Array(steps).keys()].map(i => (
                                    <span
                                        key={i}
                                        className="col-auto px-0 range-point"
                                        onClick={() => {
                                            setDisplayValue(i);
                                            onChange(i);
                                        }}
                                        onMouseOver={() => handleHover(i)}
                                        onMouseOut={handleMouseOut}
                                        style={{ cursor: 'pointer', position: 'relative' }}
                                    >
                                        <div className="position-relative">
                                            <div>|</div>
                                            <div className="range-label">{!isMobile && question.sym_explain ? question.sym_explain.split('|')[i] ?? i : i}</div>
                                        </div>
                                    </span>
                                    ))}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>

        </div>
    );
};

export default RangeQuestion;
